module.exports = __webpack_public_path__ + "static/img/gold-bg.5e37d0bf.png";